import { createContext } from 'react';
import utils from 'utils';
import { DataRoomNode } from 'router/subrouters/DataRoom/models/DataRoomNode';
import { DownloadBannerStatus } from 'models/Download';

type FileDownloadContextProps = {
  showDownloadBanner: (status: DownloadBannerStatus) => void;
  openDownloadModal: (
    dataRoomId: string,
    nodes?: DataRoomNode[],
    baseLevelNodes?: DataRoomNode[],
  ) => void;
};

export default createContext<FileDownloadContextProps>({
  showDownloadBanner: utils.noop,
  openDownloadModal: utils.noop,
});
